const MOVEX_OVERVIEW_PAGINATION_STORAGE_KEY = 'movex-overview-pagination';

function hasLocalStorage() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

function parsePositiveInteger(value, fallbackValue) {
  const parsedValue = Number.parseInt(String(value), 10);
  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : fallbackValue;
}

export function getMovexOverviewPaginationStorage({
  defaultPage = 1,
  defaultPageSize = 10,
} = {}) {
  if (!hasLocalStorage()) {
    return {
      page: defaultPage,
      pageSize: defaultPageSize,
    };
  }

  try {
    const rawValue = window.localStorage.getItem(MOVEX_OVERVIEW_PAGINATION_STORAGE_KEY);
    if (!rawValue) {
      return {
        page: defaultPage,
        pageSize: defaultPageSize,
      };
    }

    const parsedValue = JSON.parse(rawValue);

    return {
      page: parsePositiveInteger(parsedValue?.page, defaultPage),
      pageSize: parsePositiveInteger(parsedValue?.pageSize, defaultPageSize),
    };
  } catch (_) {
    return {
      page: defaultPage,
      pageSize: defaultPageSize,
    };
  }
}

export function setMovexOverviewPaginationStorage({ page, pageSize }) {
  if (!hasLocalStorage()) {
    return;
  }

  const safePage = parsePositiveInteger(page, 1);
  const safePageSize = parsePositiveInteger(pageSize, 10);

  try {
    window.localStorage.setItem(
      MOVEX_OVERVIEW_PAGINATION_STORAGE_KEY,
      JSON.stringify({
        page: safePage,
        pageSize: safePageSize,
      })
    );
  } catch (_) {
    // Ignore storage write failures.
  }
}

export function clearMovexOverviewPaginationStorage() {
  if (!hasLocalStorage()) {
    return;
  }

  try {
    window.localStorage.removeItem(MOVEX_OVERVIEW_PAGINATION_STORAGE_KEY);
  } catch (_) {
    // Ignore storage cleanup failures.
  }
}

export { MOVEX_OVERVIEW_PAGINATION_STORAGE_KEY };
